export default "__VITE_ASSET__D897WpDR__"